<div class="volunteering-dropped-out-mentors-view-part">
	<mentor-dropouts-grid-part parent='volunteering' [service]="pageService" [rows]="droppedOutMentors()"></mentor-dropouts-grid-part>
</div>